import createContextProxy from 'src/state/context/contextProxy'
import type { SharedFilesContextType } from './SharedFilesProvider'

const sharedFilesProvider = createContextProxy<SharedFilesContextType>('SharedFiles')

export const SharedFilesContext = sharedFilesProvider.ContextProxy
export const SharedFilesProvider = sharedFilesProvider.ContextProxyProvider
export const useSharedFilesState = sharedFilesProvider.useProxy
